$(document).ready(function() {
	if(!document.getElementById('inquirytoBuyForm')) return false;

	var iq = {
		el: document.getElementById('inquirytoBuyForm'),
		target: document.getElementById('appendTarget'),
		// 20200413 START 이지원 message 영역 count 수정
		textarea: document.getElementById('message'),
		init: function(){
			checkTextLength($(iq.textarea), $(iq.textarea).siblings('.left-text').find('.count'));
		// 20200414 END
			$(iq.el.selectProductCategory).on({
				change: function(e){
					// console.log();
					var _this = e.currentTarget;
					
					/* LGEGMC-144 20200414 add */
					iq.setAdobeValueAttr($(_this));
					/*//LGEGMC-144 20200414 add */
					/* LGEPL-177 */
					var url = _this.options[_this.selectedIndex].getAttribute('data-url'),
						optionText = _this.options[_this.selectedIndex].innerHTML,
						_val = _this.options[_this.selectedIndex].value;
					if(_val ==''){
						$(iq.target).empty();
					}else{
						ajax.call(url, {}, 'html', function(data){
							if(data) {
								$(iq.target).html(data);
								
								/* LGEBE-42, LGEGMC-945 Start  */
								var itFlag = true;
								if (!!$(iq.target).find('iframe').length) {
									$(iq.target).find('iframe').on('load', function() {
										runChosen();
										chosenScrollInit();
										$(iq.target).find('#selectCategoryOption').off('change').change(function(){
											$(iq.target).find('#destination-frame').attr('src',$(this).val());
										});
										$(iq.target).find('#selectCategoryOptionIT').off('change').change(function(){
											$(iq.target).find('#destination-frame').attr('src',$(this).val());
											var optionCategory = $(iq.target).find('#selectCategoryOptionIT option:checked').text();
											iq.getEloquaData(_val, optionCategory);
											itFlag=false;
										});
										
										/* LGEGMC-945 Start */
										if(itFlag){
											var optionCategory = $(iq.target).find('#selectCategoryOptionIT option:checked').text();
											if(!!optionCategory){
												iq.getEloquaData(_val, optionCategory);
											}else{
												iq.getEloquaData(_val);
											}
										}
										/*// LGEGMC-945 End */
									});
								}else{
								/*// LGEBE-42, LGEGMC-945 End */
	
								// 20200603 START 박지영 - form action으로 넘길 값이 있는 경우에만 해더에 넘기도록 수정함.
								if(iq.el.actionUrl){
									iq.el.action = iq.el.actionUrl.value;
								};
								// 20200603 END
								$(iq.el).find('.complete-wrap .completion-text .bold').text(optionText);
	
								var captchaBox = document.getElementById('customizedCaptcha');
								var captchaCate = $(captchaBox).find('input[name="productCategory"]');
								var myvalue = xssfilter(_this.value);
								if(captchaCate.get(0)) {
									captchaCate.val(myvalue);
								}else {
									$(captchaBox).prepend('<input type="hidden" name="productCategory" value="'+myvalue+'">');
								}
								runChosen();
								chosenScrollInit();
	
								if($(iq.target).find('textarea[maxlength]').length>0) {
									var obj = $(iq.target).find('textarea[maxlength]');
									checkTextLength(obj, obj.parent().find('.left-text .count'));
								}
								}
	
							}
						});
					}
					/* //LGEPL-177 */
				}
			});
			$(iq.el).on({
				validationSuccess: function(e){
					// LGECI-541 start
					var result = false;
					if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined ){
						if( !!$('#siteKey').val() && $("#useNewCaptchaView").val() == "N"){
							var reCaptcha_Key = $('#siteKey').val();
				        	grecaptcha.ready(function() {
				        		grecaptcha.execute(reCaptcha_Key, {action: 'inquiryToBuy'}).then(function(token) {
				        			$("#verifyKey").val(btoa(token));
				        			iq.sendInquiryToBuyAjax(true);
				        		});
				        	});
						}else if( !!$('#verifyKey').val() && $("#useNewCaptchaView").val() == "Y"){
							iq.sendInquiryToBuyAjax(true);
						}else{
							iq.sendInquiryToBuyAjax(true);
						}
					}else{
						iq.sendInquiryToBuyAjax( captcha.validation());
					}
					// LGECI-541 end
				},
				validationFail: function(e){
					e.preventDefault();
				},
				submit: function(e){
					e.preventDefault();
					//LGEBR-672 20210913 PageLoading 추가 START
					if(!$(this).checkValidation()){
						$('body').trigger('ajaxLoadEnd');
					}else{
						if(COUNTRY_CODE == 'br'){
							$('body').trigger('ajaxLoadBefore');
						}
					}
					//LGEBR-672 20210913 PageLoading 추가 END
				},
				/* LGEGMC-144 20200414 add */
				change: function(e){
					if (/(productSolution|products|inquiryType)/.test(e.target.name) && e.target.tagName === 'SELECT') {
						iq.setAdobeValueAttr($(e.target));
					}
				}
				/* //LGEGMC-144 20200414 add */
			});

			$('.complete-wrap').on({
				click: function(e){
					e.preventDefault();
					window.location.reload();
				}
			}, '.btn-box .btn-primary');
			
			// when loading a page, the category is already selected.
			if($(iq.el.selectProductCategory).find('option[selected]').index() != 0) {
				$(iq.el.selectProductCategory).trigger('change');
			}
		},
		sendInquiryToBuyAjax: function(result){
			// LGECI-541 start
			if(result != false) {
				var url = iq.el.action;
				var param = xssfilter($(iq.el).serialize());
				ajax.call(url, param, 'json', function(d){
					// 20200326 START 이상현 - inquiry to buy 리다이렉션 시 퍼러미터 넘김.
					if(d.redirectUrl !== undefined && d.redirectUrl !== null && d.redirectUrl !== ''  ){
						location.href = d.redirectUrl + ( ( d.redirectUrl.indexOf('?') >= 0) ? '&' : '?' ) + 'selectProductCategory=' + $('[id="selectProductCategory"]').val() + '&products=' + $('[id="productSolution"]').val();
					}else{
						if(d.result == true) {
							$(iq.el).find('.complete-wrap.success').show();
						}else {
							$(iq.el).find('.complete-wrap.fail').show();
							
							// LGECI-541 start
							if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined ){
								if( !!$('#verifyKey').val() && $("#useNewCaptchaView").val() == "Y"){
									reload_recaptcha_wrapper();
								}
							}
							// LGECI-541 end
						}
						$(iq.el).find('fieldset').hide();
						$(iq.el).find('.product-category').hide();
						$('html, body').stop().delay(100).animate({ scrollTop: 0 }, 500);
					}
					// 20200326 END
				});
			}
			// LGECI-541 end
		},
		/* LGEGMC-144 20200423 add */
		setAdobeValueAttr: function($target) {
			var val = $.trim($target.val());
			// 20200603 START 박지영 - category option 문자열 대상 변경.
			var tit = val ? ($target.find('option:selected').attr('data-meta-text') ? $.trim($target.find('option:selected').attr('data-meta-text')) : $.trim($target.find('option:selected').text())) : '';
			// 20200603 END
			$target.attr('adobe-value',tit);

			if (val) {
				var paramMap = {
					selectProductCategory:  'inquiry_to_buy_product_category_select',
					productSolution:		'inquiry_to_buy_product_solution_select',
					products:				'inquiry_to_buy_product_solution_select',
					inquiryType:			'inquiry_to_buy_inquiry_type_select'
				};
				
				iq.setClassificationCode(val); // LGEGMC-945

				var paramName = paramMap[$target[0].name];
				var param = {};
				param.page_event = {};

				param[paramName] = tit;
				/* LGEGMC-945 Start */
				param.level1 = (typeof standardData === "undefined") ? '' : standardData.level1;
				param.level2 = (typeof standardData === "undefined") ? '' : standardData.level2;
				if('inquiry_to_buy_product_category_select' != paramName){
					param.level3 = (typeof standardData === "undefined") ? '' : standardData.level3;
				}
				/*// LGEGMC-945 End */
				param.page_event[paramName] = true;
				adobeTrackEvent(paramName, param);
			}
		},
		/* LGEGMC-945 Start */
		setClassificationCode: function(categoryId){
			if(typeof standardData != 'undefined'){
				var url = '/'+COUNTRY_CODE.toLowerCase()+'/mkt/ajax/retrieveCategoryBuInfo?bizType=B2B&categoryId='+categoryId;
				$.ajax({
					type:"post",
					url: url,
					dataType: "json",
					async: false,
					xhrFields: {
						withCredentials: true
					},
					success: function(data) {
						standardData.level1 = data.data[0].buName.buName1;
						standardData.level2 = data.data[0].buName.buName2;
						standardData.level3 = data.data[0].buName.buName3;
					},
					error: function(request,status,error) {
						console.log("status: "+status);
						console.log("error: "+error);
					}
				});
			}
		},
		getEloquaData: function(superCategoryId,optionCategory){
			if(!document.getElementsByClassName('gpEloquaForm')[0]){
				return;
			}
			var iframe = document.getElementsByClassName('gpEloquaForm')[0].contentWindow;
			
			var object = {};
			object['superCategoryId'] = superCategoryId;
			if(optionCategory){
				object['categoryName'] = $.trim(optionCategory);
			}
			if(!!superCategoryId){
				var url = '/'+COUNTRY_CODE.toLowerCase()+'/mkt/ajax/inquirytobuy/getEloquaData';
				$.ajax({
					type:"post",
					url: url,
					data: object,
					dataType: 'json',
					async: false,
					xhrFields: {
						withCredentials: true
					},
					success: function(data) {
						if(data.result){
							console.log('Eloqua data search success');
							setTimeout(function() {
								iframe.postMessage(data,'*');
							}, 2000);
						}else{
							console.log('no Eloqua data');
						}
					},
					error: function(request,status,error) {
						console.log("status: "+status);
						console.log("error: "+error);
					}
				});
			}
		},
		/*// LGEGMC-945 End */
		/*//LGEGMC-144 20200423 add */
		/* BTOBGLOBAL-133 Start */
		itbIframeReady:function(e){
		    if (e.data.EloquaIframe !== 'ready') {
		      return;
		    }
		    
			var iframe = document.getElementsByClassName('gpEloquaForm')[0].contentWindow;
			var countryCode = COUNTRY_CODE.toLowerCase();
			      var acVal =
			        document.cookie.match(`(^|;) ? ${countryCode}_LGCOM_ANALYSIS_OF_SITE=([^;]*)(;|$)`) &&
			        document.cookie.match(`(^|;) ? ${countryCode}_LGCOM_ANALYSIS_OF_SITE=([^;]*)(;|$)`)[2] === 'N'
			          ? 'N'
			          : 'Y';
					  
					  
			console.log('acVal======', acVal);
			iframe.postMessage({ OPTOUT: acVal }, '*');
		} 
		/* BTOBGLOBAL-133 End */
	};
	
	iq.init();

	window.addEventListener('message', iq.itbIframeReady, false);
	
	$('#appendTarget').on('input mouseup mouseenter', 'input, textarea', function() {
		var val = $(this).val();
		$(this).val(xssfilter(val, 'form'));
	});
});